import React from 'react';
import { Card, StatusChip, Text } from '@fragments';
import { IconArrowDownLeft, IconFlag } from '@tabler/icons-react';

const CONFIG = {
    expenses: {
        label: 'Total Expenses',
        value: '$6,240.28',
        delta: '-2%',
        trend: 'down',
        icon: IconArrowDownLeft,
        points: '10,92 28,84 42,40 54,60 76,52 92,28 108,58 126,62 146,34 164,70 184,76',
    },
    balance: {
        label: 'Total Balance',
        value: '$14,480.24',
        delta: '+5%',
        trend: 'up',
        icon: IconFlag,
        points: '10,86 28,84 44,52 60,28 82,28 104,50 126,52 148,78 168,78 188,42',
    },
};

export default function MetricSnapshotCard({ type = 'expenses' }) {
    const item = CONFIG[type] || CONFIG.expenses;
    const Icon = item.icon;
    const isUp = item.trend === 'up';

    return (
        <Card flat className="metric-snapshot-card">
            <div className="metric-snapshot">
                <div className="metric-snapshot__header">
                    <span className="metric-snapshot__icon">
                        <Icon />
                    </span>
                    <Text.caption contrast={6}>{item.label}</Text.caption>
                </div>

                <div className="metric-snapshot__body">
                    <div className="metric-snapshot__value-stack">
                        <Text.h3 weight={500} contrast={10}>{item.value}</Text.h3>
                        {isUp ? (
                            <StatusChip.Success text={item.delta} />
                        ) : (
                            <StatusChip.Error text={item.delta} />
                        )}
                    </div>

                    <svg className="metric-snapshot__chart" viewBox="0 0 198 100" aria-hidden="true">
                        <polyline points={item.points} />
                    </svg>
                </div>
            </div>
        </Card>
    );
}
